export default __webpack_public_path__ + "static/media/ProductPageImage09.f34843e7.jpg";